import JsonApiRequest, { IFieldProvider, IUser } from './JsonApiRequest';
import Cache from './Cache';

class RealEstateProvider {

    cachedRealEstateProviders: Array<IFieldProvider & {cacheTime: Date}> = [];


    getById = (providerId: IFieldProvider['drupal_internal__id']): Promise<IFieldProvider> => {

        const cachedProvider = this.cachedRealEstateProviders.find((p) => p.drupal_internal__id === providerId);
        if (cachedProvider) {
            console.debug('RealEstateProvider.getById: using cached provider',providerId, cachedProvider);
            return Promise.resolve(cachedProvider);
        }

        if (Cache.get(`promise_real_estate_provider_${providerId}`)) {
            console.debug('RealEstateProvider.getById: using cached promise', providerId);
            return Cache.get(`promise_real_estate_provider_${providerId}`);
        }

        const promise =  JsonApiRequest.getRequest(`/real_estate_provider/real_estate_provider?filter[drupal_internal__id][value]=${providerId}`).then((res) => {
            const data = JsonApiRequest.data2Object<IFieldProvider>(res.getData(), true)?.find((d) => true);
            this.cachedRealEstateProviders.push({
                ...data,
                cacheTime: new Date()
            });
            console.debug('RealEstateProvider.getById: set cache', this.cachedRealEstateProviders);
            return data;
        })

        Cache.add(`promise_real_estate_provider_${providerId}`, promise, 10000); // cache promise for 10 seconds

        return promise;
    }

    getByUuid = (uuid: IFieldProvider['id']): Promise<IFieldProvider> => {

        const cachedProvider = this.cachedRealEstateProviders.find((p) => p.id === uuid);
        if (cachedProvider) {
            console.debug('RealEstateProvider.getByUuid: using cached provider',uuid, cachedProvider);
            return Promise.resolve(cachedProvider);
        }

        if (Cache.get(`promise_real_estate_provider_uuid_${uuid}`)) {
            console.debug('RealEstateProvider.getByUuid: using cached promise', uuid);
            return Cache.get(`promise_real_estate_provider_uuid_${uuid}`);
        }

        const promise = JsonApiRequest.getRequest(`/real_estate_provider/real_estate_provider/${uuid}`).then((res) => {
            const data = JsonApiRequest.data2Object<IFieldProvider>(res.getData(), true)?.find((d) => true);
            this.cachedRealEstateProviders.push({
                ...data,
                cacheTime: new Date()
            });
            console.debug('RealEstateProvider.getByUuid: set cache', this.cachedRealEstateProviders);
            return data;
        })

        Cache.add(`promise_real_estate_provider_uuid_${uuid}`, promise, 10000); // cache promise for 10 seconds

        return promise;
    }

    getByUserUuid = (userId: IUser['id']): Promise<IFieldProvider> => {
        
        const cachedProvider = this.cachedRealEstateProviders.find((p) => p.user_id?.id === userId);
        if (cachedProvider) {
            console.debug('RealEstateProvider.getByUserUuid: using cached provider',userId, cachedProvider);
            return Promise.resolve(cachedProvider);
        }

        if (Cache.get(`promise_real_estate_provider_user_${userId}`)) {
            console.debug('RealEstateProvider.getByUserUuid: using cached promise', userId);
            return Cache.get(`promise_real_estate_provider_user_${userId}`);
        }

        const promise =  JsonApiRequest.getRequest(`/real_estate_provider/real_estate_provider?filter[user_id.id][value]=${userId}`)
            .then((res) => {
                const data = JsonApiRequest.data2Object<IFieldProvider>(res.getData(), true)?.find((d) => true);
                this.cachedRealEstateProviders.push({
                    ...data,
                    cacheTime: new Date()
                });
                console.debug('RealEstateProvider.getByUserUuid: set cache', this.cachedRealEstateProviders);
                return data;
            });

        Cache.add(`promise_real_estate_provider_user_${userId}`, promise, 10000); // cache promise for 10 seconds

        return promise;
    }
}

export default new RealEstateProvider();